module.exports = __webpack_public_path__ + "img/close-icon.4305cb34.svg";